import React, { memo } from 'react';

import style from './style.module.css';

const DescriptionComponent = ({ data }) => <div className={style.host}>{data.companyDescription}</div>;

export const Description = memo(DescriptionComponent);
